export default __webpack_public_path__ + "static/media/learn-from-users-arrow-desktop.449c00df.svg";